var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7362 48C49.5807 48 51.3685 44.8755 49.9442 42.376L31.4304 9.87386C30.008 7.37767 26.4391 7.37309 25.0141 9.87386L6.49978 42.376C5.07834 44.8707 6.85785 48 9.70789 48H46.7362ZM39.22 32C39.22 38.0751 34.2951 43 28.22 43C22.1448 43 17.22 38.0751 17.22 32C17.22 25.9249 22.1448 21 28.22 21C34.2951 21 39.22 25.9249 39.22 32ZM20.7657 27.1936H23.0829C23.8649 27.1936 24.4513 27.4034 24.8423 27.823C25.2333 28.2426 25.4288 28.8576 25.4288 29.6682V30.6552C25.4288 31.4657 25.2333 32.0808 24.8423 32.5004C24.4513 32.92 23.8649 33.1298 23.0829 33.1298H22.3391V37.2064H20.7657V27.1936ZM23.0829 31.6994C23.3404 31.6994 23.5311 31.6278 23.6551 31.4848C23.7886 31.3418 23.8553 31.0986 23.8553 30.7553V29.5681C23.8553 29.2248 23.7886 28.9816 23.6551 28.8386C23.5311 28.6955 23.3404 28.624 23.0829 28.624H22.3391V31.6994H23.0829ZM26.2833 27.1936H28.6006C29.3825 27.1936 29.969 27.4034 30.3599 27.823C30.7509 28.2426 30.9464 28.8576 30.9464 29.6682V30.6552C30.9464 31.4657 30.7509 32.0808 30.3599 32.5004C29.969 32.92 29.3825 33.1298 28.6006 33.1298H27.8567V37.2064H26.2833V27.1936ZM28.6006 31.6994C28.858 31.6994 29.0487 31.6278 29.1727 31.4848C29.3062 31.3418 29.373 31.0986 29.373 30.7553V29.5681C29.373 29.2248 29.3062 28.9816 29.1727 28.8386C29.0487 28.6955 28.858 28.624 28.6006 28.624H27.8567V31.6994H28.6006ZM36.0922 27.1936H31.801V37.2064H36.0922V35.776H33.3744V32.7006H35.5343V31.2702H33.3744V28.624H36.0922V27.1936Z",
    fill: "#213D58"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.734ddae2.svg";
export { ForwardRef as ReactComponent };